import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'INFO_RAPP_HEBDO',
  title: 'Was sind wöchentliche Rapporte?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Wenn Sie wöchentliche Rapporte aktivieren, erhalten Sie wöchentlich per E-Mail eine Auflistung Ihrer Lieferanten mit deren Freigabestatus. Sie können sie auch für Ihre Nachunternehmern im Zusammenhang mit dem Projekte aktivieren.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Um Ihre Wochenberichte zu ändern, klicken Sie auf den Mann unten links'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INFO_RAPP_HEBDO/DE_INFO_RAPP_HEBDO_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Gehen Sie zu "Mein Konto"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INFO_RAPP_HEBDO/DE_INFO_RAPP_HEBDO_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Aktivieren oder deaktivieren Sie Ihre Übersichte, dann validieren Sie!'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_INFO_RAPP_HEBDO/DE_INFO_RAPP_HEBDO_3.png`
  }]
};
